/*
 * PostHog product analytics and session replay, europe only.
 *
 * Loaded the same way as utils/googleTagManager.js, for the same reasons: index.html is shared by
 * both builds (ainovel.ru measures through Yandex.Metrika), and utils/consent.js applies the
 * strictest jurisdiction to everyone, so nothing runs until the visitor has granted 'analytics'.
 * The library is imported dynamically so it is not even downloaded before that.
 *
 * The EU cloud host keeps recordings in Frankfurt. The project key must belong to a project created
 * on eu.posthog.com — a key from the US cloud is rejected by the EU host.
 *
 * Replay masks every <input>/<textarea> by default, which covers the chat box. Anything else that
 * shows personal text (the AI conversation log) should carry the `ph-no-capture` class.
 */

import { IS_EUROPE } from '../config/region';
import { allows, onConsentChange } from './consent';

const POSTHOG_KEY = 'phc_u6m5UQodSyTKF2NXG7TKwF6ddLJCBypczc76fcyftEGi';
const POSTHOG_HOST = 'https://eu.i.posthog.com';

let client = null;
let loading = null;

const start = () => {
  if (loading) return loading;
  loading = import('posthog-js').then(({ default: posthog }) => {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      defaults: '2026-05-30',
      person_profiles: 'identified_only',
      persistence: 'localStorage',
      respect_dnt: true,
      session_recording: { maskAllInputs: true },
    });
    client = posthog;
    return posthog;
  });
  return loading;
};

/* Withdrawing consent in the preference centre has to stop capture straight away, not on next load. */
const apply = (consent) => {
  if (consent.analytics) {
    start().then((posthog) => posthog.opt_in_capturing());
  } else if (client) {
    client.opt_out_capturing();
  }
};

/* Returns an unsubscribe function. Prerendering stores nothing, so allows() is false and the
   library is never loaded into the shipped HTML. */
export const initPostHog = () => {
  if (!IS_EUROPE) return undefined;
  if (allows('analytics')) start();
  return onConsentChange(apply);
};
